'use client';

import { useRef, useState } from 'react';

import { useGSAP } from '@gsap/react';
import cx from 'classnames';
import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';

import { BaseAction } from './actions/action';
import ChevronRightIcon from './icons/chevron-right.svg';
import styles from './toolbar.module.scss';

gsap.registerPlugin(useGSAP, Flip);

export interface ToolbarClientProps {
  children: React.ReactElement[];
}

export function ToolbarClient({ children }: ToolbarClientProps) {
  const rootRef = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState(true);

  useGSAP(() => {
    const root = rootRef.current;
    if (!root) {
      return;
    }
    const state = Flip.getState([root, ...root.children], {
      simple: true,
    });
    if (isExpanded) {
      root.classList.add('expanded');
    } else {
      root.classList.remove('expanded');
    }
    Flip.from(state, {
      absolute: true,
      nested: true,
      fade: true,
      onEnter: elements =>
        gsap.fromTo(
          elements,
          { opacity: 0 },
          { opacity: 1, delay: 0.05, stagger: 0.05, duration: 0.2 },
        ),
      onLeave: elements =>
        gsap.fromTo(
          elements,
          { opacity: 1 },
          { opacity: 0, delay: 0, stagger: -0.05, duration: 0.1 },
        ),
      duration: 0.4,
      ease: 'power1.inOut',
    });
  }, [isExpanded]);

  return (
    <div className={cx(styles.root, 'expanded')} ref={rootRef}>
      {children}
      <BaseAction
        tooltip={null}
        onClick={() => setIsExpanded(prev => !prev)}
        className={styles.toggleButton}
      >
        <ChevronRightIcon />
      </BaseAction>
    </div>
  );
}
